module cr.events {
    class xcoController {
        static $inject = ['xcoService','$scope', '$stateParams','$modal','$state','raceList' ];

        constructor(private xcoService, private $scope, private $stateParams, private $modal,$state,public raceList) {
            $scope.context="chronorace";

            console.log("xcoController ok: "+angular.toJson(raceList));

            if (raceList && raceList.length>0)
            {
                $state.go("xco.race",{raceName: raceList[0] });
            }
        }
    }
    eventModule.controller('xcoController', xcoController);

    class xcoRaceController {
        static $inject = ['xcoService','$scope', '$stateParams','$modal','$state','registration','overview' ,'$interval'];

        FormatTime=input=>{
            if (!input) {
                return "";
            }

            var ms = input % 1000;
            input = (input - ms) / 1000;
            var secs:string = input % 60 + "";
            input = (input - +secs) / 60;
            var mins:string = input % 60 + "";
            var hrs:string = (input - +mins) / 60 + "";

            if (+hrs>0)
            {
                if (+mins < 10 ){
                    mins = '0' + mins;
                }
                if (+secs < 10) {
                    secs = '0' + secs;
                }

                return hrs + ':' + mins + ':' + secs;
            }
            if (+mins>0)
            {
                if (+secs < 10) {
                    secs = '0' + secs;
                }
                return mins + ':' + secs;
            }

            return secs;
        }


        GetLapTimes=(ov)=> {
            if (!angular.isDefined(ov.LapTimes)) return "";
            var i=ov.LapTimes.length-10;
            if (i<0) i=0;


            var toRet="";
            var first=true;
            while (i<ov.LapTimes.length)
            {
                if (!first) toRet=toRet+", ";
                toRet=toRet+this.FormatTime(ov.LapTimes[i]);
                first=false;
                i++;
            }

            return toRet;
        }

        GetRacePosition=(ov)=>{
            if (!angular.isDefined(ov.CurrentSituation)) return "";

            if (+ov.CurrentSituation.Lap==0) return "STRT";
            if (+ov.CurrentSituation.LapLocation>0)
            {
                return "Lap "+ov.CurrentSituation.Lap+" / ctrl "+ov.CurrentSituation.LapLocation;
            }

            return "Lap "+ov.CurrentSituation.Lap;
        }

        constructor(private xcoService, private $scope, private $stateParams, private $modal,$state,public registration,public overview,public $interval)
        {
            var i=0;
            var timer = $interval(()=>
            {
                xcoService.overview($stateParams.db,$stateParams.raceName).then(data=>{
                    console.log("overview");
                    this.overview=data;
                });
                i++;
                if (i>20)
                {

                    xcoService.overview($stateParams.db,$stateParams.raceName).then(data=>{
                        console.log("registration");
                        this.registration=registration;
                    });

                    i=0;
                }
            },3000);

            $scope.$on('$destroy', () => {
                // Make sure that the interval is destroyed too
                $interval.cancel(timer);
            });
        }
    }
    eventModule.controller('xcoRaceController', xcoRaceController);



    eventModule
        .filter('mstotimehmmss', () => {
            return (input) => {
                if (!input) {
                    return "";
                }

                var ms = input % 1000;
                input = (input - ms) / 1000;
                var secs:string = input % 60 + "";
                input = (input - +secs) / 60;
                var mins:string = input % 60 + "";
                var hrs:string = (input - +mins) / 60 + "";

                /*  if (+hrs < 10) {
                 hrs = '0' + hrs;
                 }*/



                if (+hrs>0)
                {
                    if (+mins < 10 ){
                        mins = '0' + mins;
                    }
                    if (+secs < 10) {
                        secs = '0' + secs;
                    }

                    return hrs + ':' + mins + ':' + secs;
                }
                if (+mins>0)
                {
                    if (+secs < 10) {
                        secs = '0' + secs;
                    }
                    return mins + ':' + secs;
                }

                return secs;
            }
        });
    eventModule
        .filter('mstotimehmmssf', () => {
            return (input) => {
                if (!input) {
                    return "";
                }

                var ms = input % 1000;
                input = (input - ms) / 1000;
                var secs:string = input % 60 + "";
                input = (input - +secs) / 60;
                var mins:string = input % 60 + "";
                var hrs:string = (input - +mins) / 60 + "";

                /*  if (+hrs < 10) {
                 hrs = '0' + hrs;
                 }*/



                if (+hrs>0)
                {
                    if (+mins < 10 )mins = '0' + mins;
                    if (+secs < 10) secs = '0' + secs;
                    return hrs + ':' + mins + ':' + secs+'.'+~~(ms/100);
                }
                if (+mins>0)
                {
                    if (+secs < 10) secs = '0' + secs;
                    return mins + ':' + secs+'.'+~~(ms/100);
                }

                return secs+'.'+~~(ms/100);
            }
        });

        eventModule.filter('mstotimehmmssfff', () => {
            return (input) => {
                if (!input) {
                    return "";
                }



                var ms = input % 1000;

                var strMs=(ms+1000).toString().substr(1);

                input = (input - ms) / 1000;
                var secs:string = input % 60 + "";
                input = (input - +secs) / 60;
                var mins:string = input % 60 + "";
                var hrs:string = (input - +mins) / 60 + "";

                /*  if (+hrs < 10) {
                 hrs = '0' + hrs;
                 }*/



                if (+hrs>0)
                {
                    if (+mins < 10 )mins = '0' + mins;
                    if (+secs < 10) secs = '0' + secs;
                    return hrs + ':' + mins + ':' + secs+'.'+strMs;
                }
                if (+mins>0)
                {
                    if (+secs < 10) secs = '0' + secs;
                    return mins + ':' + secs+'.'+strMs;
                }

                return secs+'.'+strMs;
            }
    });


}
